import PropTypes from 'prop-types';

import { ENV_VARS } from 'ENV_CONFIG';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>Your appointment is for one room and lasts up to 90 minutes</li>
    <li>
      Bring along room dimensions or a floor plan with measurements so we can plan with sizes and
      proportions in mind
    </li>
    <li>Please bring any research, mood boards or photographs of your space if possible</li>
    <li>
      To find out more about the Home Design service please&nbsp;
      <a href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/home-design-service`}>visit our website</a>
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};

export const RemoteAppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      At the time of your virtual appointment, we&apos;ll call you on the number provided.
      It&apos;ll be useful to have access to the internet, as we will discuss products on&nbsp;
      <a href={`${ENV_VARS.REACT_APP_BROWSE_HOST}`} target="_blank" rel="noopener noreferrer">
        johnlewis.com
      </a>
    </li>
    <li>
      This appointment will be conducted either over the phone or via video call, whichever you
      prefer
    </li>
    <li>
      As the appointment is tailored to your home, if you have any specific dimensions or
      measurements you would like to provide, these would be helpful
    </li>
    <li>
      Feel free to share any mood boards, Pinterest or social media accounts with us for inspiration
    </li>
    <li>
      To find out more about the Home Design service please&nbsp;
      <a
        href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/home-design-service`}
        target="_blank"
        rel="noopener noreferrer"
      >
        visit our website
      </a>
    </li>
    {listItem}
  </ul>
);

RemoteAppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
